import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  VStack,
  Text,
  Button,
  HStack,
  Divider,
} from '@chakra-ui/react';
import { FiMail } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import webCore from '@happylife-a/web-core';

export default function AIProductContentGeneratorPackageUpgradeModal({ onClose }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <Modal size="4xl" isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        h={{ base: '100%', md: 'fit-content' }}
        borderRadius={{ base: 0, md: '17px' }}
        my={{ base: 0, sm: 16 }}
        overflow={{ base: 'auto', md: 'visible' }}
      >
        <ModalBody pb={0} px={0} bg="primary.600" borderRadius={{ base: 0, md: '17px' }}>
          <VStack spacing={6} py={10} px={{ base: 4, md: 10 }} align="center">
            <Text fontSize="2xl" fontWeight="bold" color="white" textAlign="center">
              {t('Upgrade Your AI Product Content Generator')}
            </Text>
            <Text fontSize="md" color="whiteAlpha.900" opacity={0.95} textAlign="center">
              {t(
                'To unlock more AI-powered product content generations, please contact us via WhatsApp or Email.'
              )}
            </Text>
            <Divider borderColor="whiteAlpha.500" />
            <HStack spacing={4}>
              <Button
                as="a"
                href="https://wa.me/+37494735555"
                target="_blank"
                leftIcon={<FaWhatsapp size={20} />}
                colorScheme="whatsapp"
                variant="solid"
                borderRadius="full"
                fontWeight="medium"
                px={6}
              >
                WhatsApp
              </Button>
              <Button
                as="a"
                href="mailto:info@layf.space"
                leftIcon={<FiMail size={20} />}
                colorScheme="gray"
                variant="outline"
                borderRadius="full"
                fontWeight="medium"
                px={6}
                _hover={{
                  bg: 'whiteAlpha.200',
                  borderColor: 'whiteAlpha.700',
                  color: 'white',
                }}
                borderColor="whiteAlpha.700"
                color="white"
              >
                {t('Email')}
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
